import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// La coquille fait défiler sa colonne principale, pas la fenêtre (barre latérale et en-tête fixes) :
// on la remonte en haut à chaque changement de page, sauf vers une ancre (ScrollToAnchor s'en charge).
export function useScrollTopOnNavigation() {
  const ref = useRef<HTMLDivElement>(null);
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash && ref.current) ref.current.scrollTop = 0;
  }, [pathname, hash]);
  return ref;
}
